import {Directive, ElementRef, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appEndDateTimePicker]'
})
export class EndDateTimePickerDirective implements AfterViewInit {
    @Input() value: any;
    @Output() onChange = new EventEmitter<string>();
    private element: any;

    constructor(el: ElementRef) {
        this.element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        const defaultEndDate = new Date();
        defaultEndDate.setHours(23, 59, 0, 0);

        this.element.daterangepicker({
            autoApply: true,
            singleDatePicker: true,
            timePicker: true,
            startDate: this.value || defaultEndDate,
            locale: {
                format: 'DD/MM/YYYY hh:mm A'
            }
        });

        this.element.val(this.value || this.formatDate(defaultEndDate)).trigger('change');
        
        this.element.val(this.value).trigger('change');
        this.element.on('change', (e: any) => {
            this.onChange.emit($(e.target).val());
        });
    }

    private formatDate(date: Date): string {
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = ('0' + (hours % 12 || 12)).slice(-2);
    
        return `${month}/${day}/${year} ${formattedHours}:${minutes} ${ampm}`;
      }
}
